<template>
    <div class="vue-form">
        <form
            :name="name"
            :action="action"
            :method="method"
            :novalidate="novalidate"
            @submit.prevent="submit">
            <slot />
        </form>
    </div>
</template>

<script src="./vue-form.js"></script>
